import Spinner from 'src/javascripts/components/utilities/Spinner';
import 'blueimp-file-upload/js/jquery.fileupload.js';

export default class AdminDataFrameworksWeightsImportsNew {

  constructor() {}

  render() {
    $('.framework-weights-filepicker').each(function(i, elem) {
      let fileInput   = $(elem);
      let frameworkId = fileInput.data('framework-id');
      let progressBar = $("<div class='bar'></div>");
      let barContainer = $("<div class='progress'></div>").append(progressBar);
      $('#fileUploadProgress').append(barContainer);

      fileInput.fileupload({
        fileInput:        fileInput,
        url:              fileInput.data('url'),
        type:             'POST',
        autoUpload:       true,
        formData:         fileInput.data('form-data'),
        paramName:        'file',
        dataType:         'XML',
        replaceFileInput: false,

        progressall: function(e, data) {
          let progress = parseInt(data.loaded / data.total * 100, 10);
          progressBar.css('width', progress + '%');
        },

        start: function() {
          progressBar
            .css('background', '#8c81d1')
            .css('display', 'block')
            .css('width', '0%')
            .text('Loading...');
        },

        done: function(e, data) {
          progressBar.text('Uploading...');

          let key        = $(data.jqXHR.responseXML).find('Key').text();
          let accountUrl = $('body').attr('data-account-url');

          $('.filepicker-container .filepicker-label').addClass('opaque');
          Spinner($('.filepicker-container'));

          if (key.slice(-4) !== 'xlsx') {
            let url = '/admin/data/frameworks/' + frameworkId + '/weights_imports/new';
            Turbo.visit(url + '?message=Only .xlsx files are allowed');
            return;
          }

          let url      = '/admin/data/frameworks/' + frameworkId + '/weights_imports';
          let formData = { file: { key: key } };

          $.ajax({
            type:     'POST',
            url:      url,
            dataType: 'application/json',
            headers:  { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
            data:     formData,
            complete(result) {
              let params   = {};
              let redirect = '/admin/data/frameworks/' + frameworkId + '/pillars';
              if (result.status === 200) {
                params['message'] = 'Your weights are being imported. This usually takes less than one minute.';
              } else {
                params['message'] = 'There was a problem importing your file. Please try again or contact support.';
              }
              Turbo.visit(redirect + '?' + $.param(params));
            }
          });
        },

        fail: function() {
          progressBar.css('background', 'red').text('Failed');
        }
      });
    });
  }

}
